// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._76QXSUwXNv-sZ8hIa-lnew\\=\\={display:flex;flex-direction:column;width:100%}", "",{"version":3,"sources":["webpack://./src/pages/Couriers/components/CourierDetailsActionsAddInput/CourierDetailsActionAddInput.module.scss"],"names":[],"mappings":"AAAA,6BACI,YAAA,CACA,qBAAA,CACA,UAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_add_input": "_76QXSUwXNv-sZ8hIa-lnew=="
};
export default ___CSS_LOADER_EXPORT___;
